const form = document.getElementById('contact_form');

// Scroll to form if it has been submitted
const params = new URL(document.location).searchParams;
const formPosted = params.get('contact_posted');
if (formPosted) {
  setTimeout(() => {
    form.scrollIntoView({ behavior: 'smooth' });
  }, 1000);
}
